
export function requires(...variables) {
    for (const [key, value] of variables.entries()) {
        if (value === null || value === undefined) {
            throw new Error(`Missing value for: ${key}`)
        }
    }
}